import { MarketMakingServices } from './market-making-services.factory';

export interface MarketMakingPlatform {
  id: string;
  routePath: string;
  displayName: string;
  backendId: number;
  backendName: string;
  apiBasePath: string;
  wsBaseUrl: string;
  wsStatusKey: string;
  hedgeAccountId?: number;
  services: MarketMakingServices;
}

export function toTradeLabel(displayName: string): string {
  return `${displayName} Trade`;
}

export function toHedgeLabel(displayName: string): string {
  return `${displayName} Hedge`;
}

export function toRoutePath(displayName: string): string {
  return displayName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function toPlatformId(routePath: string): string {
  return routePath.replace(/-([a-z0-9])/g, (_, char: string) => char.toUpperCase());
}
